import { connect } from 'react-redux';
import ReportPage from './index';
import { mapDispatchToProps, mapStateToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage);
